module.exports = __webpack_public_path__ + "media/assets/interactivity-3d38773ca7ae8f4f51e559dab96af06e.png";